module.exports = __webpack_public_path__ + "img/publish.a7577aff.png";